import React, { useEffect, useState } from "react";
import sal from "sal.js";

import Link from "next/link";
import { setCookie, getCookie } from 'cookies-next';
import {useRouter} from 'next/navigation';

const Pricing = ({messages}) => {
  const router = useRouter();

  const [PricingData, setPricingData] = useState({
      "pricing": []
    }
  );

 const [Category, setCategory] = useState([]);

  async function purchase(id) {
    let cookie = {
      id: id,
      yearly: false
    }
    let options = { maxAge: 60 * 60 * 24 * 7, path: '/' }; 
    setCookie('basket', cookie, options);
    router.replace("pre-payment");
  }


  useEffect(() => {
    async function fetchCategory() {
      const response = await fetch("/api/billing/category");
      const data = await response.json();
      setCategory(data);
    }

    fetchCategory();

   async function fetchPackages() {
    const response = await fetch("/api/billing/packages");
    const data = await response.json();
    const formattedData = data.map((packageItem) => ({
      id: packageItem.id,
      title: JSON.parse(packageItem.name)["tr"],
      price: packageItem.monthly_price,
      yearly_price: packageItem.yearly_price,
      property: JSON.parse(packageItem.property),
      category: JSON.parse(packageItem.category),

      text: packageItem.text || "", // Text varsa price gözükmez not 
      subTitle: packageItem.credit+" "+messages["kredi"], 
      isActive: packageItem.isActive || true, 
      subItem: JSON.parse(packageItem.highlight).map((sub) => ({
        text: sub.tr || "", 
        isMinus: (sub.status == "1" ? false : true)
      }))
    }));
    setPricingData({ pricing: formattedData });
   }
   fetchPackages();
 }, [])

  useEffect(() => {
    sal();

    const cards = document.querySelectorAll(".bg-flashlight");

    cards.forEach((bgflashlight) => {
      bgflashlight.onmousemove = function (e) {
        let x = e.pageX - bgflashlight.offsetLeft;
        let y = e.pageY - bgflashlight.offsetTop;

        bgflashlight.style.setProperty("--x", x + "px");
        bgflashlight.style.setProperty("--y", y + "px");
      };
    });
  }, []);
  return (
    <>
      <div className="rainbow-pricing-area rainbow-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="section-title text-center"
                data-sal="slide-up"
                data-sal-duration="400"
                data-sal-delay="150"
              >
                <h4 className="subtitle ">
                  <span className="theme-gradient">{messages["fiyatlandirma"]}</span>
                </h4>
                <h2 className="title w-600 mb--20">
                  {messages["pricing-title"]}
                </h2>
                <p className="description b1">
                  {messages["pricing-desc"]}
                </p>
              </div>
            </div>
          </div>
          <div className="row row--15">
            {PricingData &&
              PricingData.pricing.slice(0, 3).map((data, index) =>{
                // console.log(data);
                return (
                  <div className="col-lg-4 col-md-6 col-12" key={index}>
                  <div
                    className={`rainbow-pricing style-2 ${
                      data.isActive ? "active" : ""
                    }`}
                  >
                    <div className="pricing-table-inner bg-flashlight">
                      <div className="pricing-header">
                        <h4 className="title">{data.title}</h4>
                        <div className="pricing">
                          <div className="price-wrapper">
                            <span className="price">
                              {data.price === 0 ? "Free" : data.price}
                            </span>
                            {data.price === 0 ? (
                              ""
                            ) : (
                              <span className="currency">₺</span>
                            )}
                          </div>
                          <span className="subtitle">
                            {data.subTitle.split(' ').map(word => 
                              !isNaN(word) ? parseInt(word).toLocaleString('tr-TR') : word
                            ).join(' ')}
                          </span>
                        </div>
                      </div>
                      <div className="separator-animated animated-true mt--30 mb--30"></div>
                      <div className="pricing-body">
                        <ul className="list-style--1">
                          {data.subItem.map((innerData, innerIndex) => (
                            <li key={innerIndex}>
                              <i
                                className={`feather-${
                                  innerData.isMinus ? "minus" : "check"
                                }-circle pe-2`}
                              ></i>
                              {innerData.text}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="pricing-footer">
                        {data.price === 0 ? (
                          <a className="btn-default btn-border" onClick={() => purchase(data.id)}>
                            {messages["try"]}
                          </a>
                        ) : (
                          <a
                            className={`btn-default ${
                              !data.isActive ? "btn-border" : ""
                            }`}
                            onClick={() => purchase(data.id)}
                          >
                            {messages["buy"]}
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                )
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Pricing;
